
import React , {useState, useEffect}from "react";
import classnames from "classnames";
import { useLocation } from "react-router-dom";
import { useNavigate , useHistory} from 'react-router-dom';
import { Card, CardBody, Badge, Row, Col , Button} from "reactstrap";
import ReactTable from "components/ReactTable/ReactTablebep.js";
import Spin from '../../assets/img/Spinner2.gif'
   
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
  
  
function Logs(props) {
    let d = new Date()
        d.setDate(d.getDate() - 7);


    const [showProcessing, setShowProcessing] = useState(false)
    const [data, setData ] = useState([])
    const SpinnerNew = <div className="spoverlay"><center><img style={{marginTop : 200}} src={Spin} alt="a" width={"200px"}/><h4>Please wait...</h4></center></div>

    const [sdate , setSdate] = useState(d)
    const [edate , setEdate] = useState(new Date())
    
    const [limit, setLimit] = useState(10)
    const [total, setTotal] = useState(1)
    const [pageNumber, setPageNumber] = useState(0) 
    

   
    const nextpage = () => {
        let page = pageNumber === 0 ?  1  : pageNumber;
        if(Math.ceil(total/limit) >= pageNumber + 1){
            
            setPageNumber(pageNumber + 1)
            page = pageNumber + 1 
        }else{
            
            page = pageNumber
            
        }
        let npage = page -1 
        let tskip = pageNumber === 0 ?  0 : npage  * limit        
        
        getlogs(tskip)
        
        
    }
    const previouspage = () => {
        let page = pageNumber === 0 ?  0  : pageNumber -1 ;
        if(page <= 0){
            
            setPageNumber(0)
            getlogs(0)
        }else{
            
            page = pageNumber -1 
            let tskip = page  * limit      
            setPageNumber(page)  
            getlogs(tskip)
        }
        
        
        //console.log(total)    
          
    
    }

    const betweendates = () => {
        let xdata = []
        data.map(t => xdata.push({
            eventid : t.eventid,
            summary : t.summary,
            tenantId : t.tenantId,
            action : t.action,
            actionBy : t.actionBy,
            cdate : t.cDate,
            eventBy : t.eventBy
        }))
        return (
            
                <Row style={{marginTop : 15, paddingLeft : 10}}>
                      <Col style={{margin : 0}}>From  : <DatePicker selected={sdate} onChange={(date) => setSdate(date)} maxDate={edate}/></Col>
                    <Col style={{padding : 0, margin :0}}>To : <DatePicker selected={edate} onChange={(date) => setEdate(date)} minDate={sdate} /></Col>
                    
                    <Col><i className="fa fa-download" aria-hidden="true" style={{float : "right", cursor : "pointer", paddingRight : 30, marginTop : 5}} onClick={g => {exportCSVFile(headers, data,"Logs")}}></i>
                     <i className="fa fa-refresh" aria-hidden="true" style={{padding : 0}} onClick={k => getlogs(0)}></i>
                    </Col>
                    <Col>
                 
                    </Col>
                </Row>
            
        )
    }

    const getlogs = (typee) => {
            setShowProcessing(true)
             props.API.get(`ten/getlogs/${typee}/${limit}/${sdate}/${edate}`, { headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
            setData(res.data.data)
            
            setTotal(res.data.total)
            setShowProcessing(false)
         
          }).catch(function (error) {
            setShowProcessing(false)
          }) 
    }

    function convertToCSV(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = '';
    
        for (var i = 0; i < array.length; i++) {
            var line = '';
            for (var index in array[i]) {
                if (line != '') line += ','
    
                line += array[i][index];
            }
    
            str += line + '\r\n';
        }
    
        return str;
    }

    function exportCSVFile(headers, items, fileTitle) {
        if (headers) {
            items.unshift(headers);
        }
    
        // Convert Object to JSON
        var jsonObject = JSON.stringify(items);
    
        var csv = convertToCSV(jsonObject);
    
        var exportedFilenmae = fileTitle + '.csv' || 'export.csv';
    
        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, exportedFilenmae);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilenmae);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    var headers = {
        eventid : "eventid",
        summary : "summary",
        tenantId : "tenantId",
        action: 'action', // remove commas to avoid errors
        actionBy: "actionBy",
        Created: "cDate",
        eventBy : "eventBy",

    };
    

    return (
        <div className="content">
        
               {showProcessing && SpinnerNew } 
                      <Card>
                      {betweendates()}
                      
                   <CardBody >
                         <ReactTable 
                           data= {data}
                           nextpage = {nextpage}
                           totalpages = {Math.floor(Number(total)/Number(limit))}
                           pagenumber = {pageNumber}
                           pagesize = {limit}
                           previouspage={previouspage}
                           pageNumber = {pageNumber}
                           setPageNumber={setPageNumber}
                           setLimit={setLimit}
                           limit={limit}
                           columns={[
                            {
                                Header: "DateTime",
                                accessor: d =>  <span>{new Date(d.cDate).toDateString()}  {new Date(d.cDate).toLocaleTimeString()}</span>,
                                maxWidth : -20
                            }, 
                            {
                                 Header: "By",
                                 accessor: d =>  d.actionBy,
                                 
                               },
                               
                             {
                               Header: "Tenant",
                               accessor: d =>  d.tenantId ,
                            
                            },
                            
                             {
                               Header: "Action",
                               accessor: d => d.action,
                             },
                             {
                                 Header: "Summary",
                                 accessor: d =>  d.summary,
                                
                               },
                            
                           ]}
                           /*
                               You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                             */
                           className="-striped -highlight primary-pagination"
                         />
                       </CardBody>
                    
             </Card>
        </div>
    );
}

export default Logs;
